// extracted by mini-css-extract-plugin
module.exports =  {"checkbox-wrapper":"_93444fe79c--checkbox-wrapper--ovQyh","focused":"_93444fe79c--focused--VEc4h"};